import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { connect } from "react-redux";
import queryParser from 'query-string-parser';
import { withStyles, Paper } from "@material-ui/core";
import * as actions from "../../../sc-core/Auth/store/authActions";
import { safeParse } from "../../../sc-utilities";
import CreateUserForm from "./CreateUserForm";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2)
    },
    btn: { textAlign: 'right', marginLeft: '50%', marginBottom: '0.3rem' },
    formControl: {
        marginTop: theme.spacing(5),
        width: "100%",
        marginBottom: '5px',
    },
    dialogPaper: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        minHeight: '15vh',
        minWidth: '70vh'
    },
    submit: {
        width: "100%",
        color: theme.palette.buttonText.default,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
});

const CreateUser = props => {

    const { translations, classes, onCreateOpenIDUser } = props;

    const [userInfo, setUserInfo] = useState(null);
    const [claims, setClaims] = useState(null);
    const [stateString, setStateString] = useState("");
    useEffect(() => {
        const urlOptions = queryParser.fromQuery(window.location.search);

        urlOptions.userinfo && setUserInfo(safeParse(urlOptions.userinfo));
        urlOptions.claims && setClaims(safeParse(urlOptions.claims));
        urlOptions.state && setStateString(urlOptions.state);
    }, []);

    const createUserInitialValues = {
        FirstName: userInfo?.given_name ?? '',
        LastName: userInfo?.family_name ?? '',
        Email: userInfo?.email ?? '',
        Username: '',
        Password: '',
    }

    let createUserFormSettings = {
        Validation: {
            FirstName: Yup.string().required("Required"),
            LastName: Yup.string().required("Required"),
            Username: Yup.string().required("Required"),
            Password: Yup.string().required("Required"),
            Position: Yup.string().required("Required"),
        },
        ButtonSubmit: {
            Title: "Submit",
            Color: "primary"
        },
        FormTitle: translations['create_openid_user'] || 'Create OpenID Techincal User',

    };

    const handleCreateUser = async (data) => {
        const userParams = {
            ...data,
            State: stateString,
            ClientType: "dashboard_client",
            ClientVersion: "2.8",

        }
        let res = await onCreateOpenIDUser(userParams);
        if (res.data.result.data.redirectURL) {
            window.location.href = res.data.result.data.redirectURL;
        }
    };


    return (
        userInfo && claims && stateString &&
        <Paper className={classes.root} >
            <CreateUserForm
                translations={translations}
                handleSubmit={handleCreateUser}
                initialValues={createUserInitialValues}
                formSettings={createUserFormSettings} />
        </Paper>
    )
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateOpenIDUser: data => dispatch(actions.createOpenIDUser(data)),
    };
};


export default connect(
    null,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CreateUser));
